<form id="safeDeleteForm" role="dialog" aria-modal="true" [attr.aria-labelledby]="'modal-title'" [attr.aria-describedby]="'modal-description'">
  <div class="tw-flex tw-justify-end tw-mr-2">
    <button type="button" mat-icon-button class="close" (click)="dismissModal()" data-dismiss="modal" aria-label="Click to close this modal">
      <streamline-icon name="close" width="10" height="10"></streamline-icon>
    </button>
  </div>
  <h4 id="modal-title" class="tw-text-center">Delete Company?</h4>
  <mat-dialog-content>
    <p id="modal-description">Are you sure you want to delete the company <strong>{{name}}</strong>? This operation cannot be undone! Please type DELETE to confirm.</p>
    <input id="safeDeleteInput" name="safeDeleteInput" type="text" [(ngModel)]="inputText" class="form-control" (input)="refreshInput()" aria-label="Type DELETE to confirm deletion" />
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-gap-4">
    <button mat-stroked-button type="button" (click)="dismissModal()">
      Cancel
    </button>
    <button id="deleteForeverButton" mat-flat-button color="primary" type="submit" (click)="confirm()" [disabled]="!canConfirm()">
      Delete Forever
    </button>
  </mat-dialog-actions>
</form>
